// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    TCApiGatewayControllersCardModelsCardMemberRequestModel,
    TCApiGatewayControllersCardModelsCardProgramRequestModel,
    TCApiGatewayControllersCardModelsCreateCardRequestModel,
    TCApiGatewayControllersHelpersModelsCompleteTaskRequestModel,
    TCApiGatewayControllersHelpersModelsUpdateTaskRequestModel,
    TCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel,
    TCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel,
    TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountDisplayIdRequestModel,
    TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel,
    TCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel,
    TCApiGatewayControllersModelsRequestTypesNewNoteRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class DefaultApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel 
     */
    public async bmsGetNextBusinessDay (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel?: TCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Bms/getNextBusinessDay';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel, "TCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel 
     */
    public async bmsScheduleAppointment (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel?: TCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Bms/scheduleAppointment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel, "TCApiGatewayControllersModelsRequestTypesBmsScheduleAppointmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersCardModelsCreateCardRequestModel 
     */
    public async cardCreateCard (xProgramId?: string, tCApiGatewayControllersCardModelsCreateCardRequestModel?: TCApiGatewayControllersCardModelsCreateCardRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Card/createCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersCardModelsCreateCardRequestModel, "TCApiGatewayControllersCardModelsCreateCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersCardModelsCardProgramRequestModel 
     */
    public async medBenefitReplaceCard (xProgramId?: string, tCApiGatewayControllersCardModelsCardProgramRequestModel?: TCApiGatewayControllersCardModelsCardProgramRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Card/medBenefit/replaceCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersCardModelsCardProgramRequestModel, "TCApiGatewayControllersCardModelsCardProgramRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersHelpersModelsCompleteTaskRequestModel 
     */
    public async noteComplete (xProgramId?: string, tCApiGatewayControllersHelpersModelsCompleteTaskRequestModel?: TCApiGatewayControllersHelpersModelsCompleteTaskRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Note/Complete';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersHelpersModelsCompleteTaskRequestModel, "TCApiGatewayControllersHelpersModelsCompleteTaskRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesCreateTaskByAccountDisplayIdRequestModel 
     */
    public async noteCreateByAccountDisplayId (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesCreateTaskByAccountDisplayIdRequestModel?: TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountDisplayIdRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Note/createByAccountDisplayId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesCreateTaskByAccountDisplayIdRequestModel, "TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountDisplayIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel 
     */
    public async noteCreateByAccountId (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel?: TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Note/CreateByAccountId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel, "TCApiGatewayControllersModelsRequestTypesCreateTaskByAccountIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesNewNoteRequest 
     */
    public async noteCreateNote (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesNewNoteRequest?: TCApiGatewayControllersModelsRequestTypesNewNoteRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Note/CreateNoteAsync';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesNewNoteRequest, "TCApiGatewayControllersModelsRequestTypesNewNoteRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersHelpersModelsUpdateTaskRequestModel 
     */
    public async noteUpdate (xProgramId?: string, tCApiGatewayControllersHelpersModelsUpdateTaskRequestModel?: TCApiGatewayControllersHelpersModelsUpdateTaskRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Note/Update';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersHelpersModelsUpdateTaskRequestModel, "TCApiGatewayControllersHelpersModelsUpdateTaskRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel 
     */
    public async policyReporterGetMedicareReport (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel?: TCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/PolicyReporter/getMedicareReport';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel, "TCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersCardModelsCardMemberRequestModel 
     */
    public async v2ActivateCard (xProgramId?: string, tCApiGatewayControllersCardModelsCardMemberRequestModel?: TCApiGatewayControllersCardModelsCardMemberRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Card/v2/activateCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersCardModelsCardMemberRequestModel, "TCApiGatewayControllersCardModelsCardMemberRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async v2CreateCard (xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Card/v2/createCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
}
